<template>
  <div class="login">
    <captcha-slider :key="keyVerify" v-if="dialogVerify" @success="callbackVerifySuccess"/>
    <svg class="img1">
      <use xlink:href="#icon-logo"></use>
    </svg>
    <div class="login_box">
      <div class="left">
        <img src="../../assets/images/wh9.png" alt="" class="img2">
      </div>
      <div class="right" style="width: 450px;height: 380px;">
        <div class="top">
          <h1>快速登录</h1>
          <div class="line"></div>
        </div>
        <div v-show="!isDD">
          <div class="mid" style="margin-top: 60px;">
            <el-form>
              <el-input type="text" v-model="params.account" placeholder="请输入用户名"
                        suffix-icon="el-icon-user-solid"
                        class="input1"/>
              <el-input type="password" v-model="params.password" placeholder="请输入密码"
                        suffix-icon="el-icon-lock"
                        @keyup.enter.native="doLogin"/>
            </el-form>
            <div class="err">
              {{ errmessage }}
            </div>
          </div>
          <el-button @click="doLogin" class="btn login-btn" type="primary" :loading="loginLoading"
                     :disabled="loginLoading">登录
          </el-button>
          <div style="margin-top: 10px">
            第三方登录
          </div>
          <p style="color:#409EFF;cursor: pointer; font-size: 14px">
            <span @click="ddQuickLogin"><i class="iconfont icon-dingding"
                                           style="font-size: 18px;margin-right: 4px;display: inline-block"></i>钉钉登录</span>
            <span @click="fsQuickLogin" style="margin-left: 10px"><svg class="fs-login-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none"><rect width="16" height="16" rx="2" fill="white"/>
<path d="M8.5611 8.26287L8.59322 8.23075C8.6141 8.20988 8.63658 8.18739 8.65906 8.16652L8.70402 8.12316L8.8373 7.99148L9.02037 7.81324L9.17613 7.65908L9.32226 7.51456L9.47481 7.36361L9.61452 7.22551L9.81043 7.03281C9.84737 6.99588 9.8859 6.96055 9.92444 6.92522C9.9951 6.86099 10.069 6.79836 10.1428 6.73734C10.2119 6.68274 10.2825 6.62975 10.3548 6.57836C10.456 6.5061 10.5603 6.44026 10.6663 6.37603C10.7707 6.31501 10.8783 6.2572 10.9875 6.2026C11.0903 6.15282 11.1963 6.10625 11.3038 6.0645C11.3633 6.04041 11.4243 6.01954 11.4853 5.99866C11.5158 5.98903 11.5463 5.97779 11.5784 5.96815C11.3071 4.90028 10.8109 3.90468 10.122 3.04556C9.98868 2.88016 9.78634 2.78381 9.57438 2.78381H3.94598C3.88817 2.78381 3.84 2.83038 3.84 2.8898C3.84 2.92352 3.85605 2.95403 3.88335 2.97491C5.80391 4.38321 7.39689 6.19297 8.54826 8.27732L8.5611 8.26287Z" fill="#00D6B9"/>
<path d="M6.32424 13.2168C9.23077 13.2168 11.7631 11.6126 13.0831 9.24238C13.1297 9.15887 13.1747 9.07537 13.218 8.99026C13.1522 9.11712 13.0783 9.23917 12.9964 9.35478C12.9675 9.39493 12.9386 9.43508 12.9081 9.47522C12.8696 9.525 12.831 9.57157 12.7909 9.61814C12.7588 9.65507 12.7266 9.6904 12.6929 9.72573C12.6255 9.79638 12.5548 9.86383 12.4809 9.92646C12.4392 9.96178 12.3991 9.99551 12.3557 10.0276C12.3059 10.0662 12.2545 10.1031 12.2031 10.1368C12.171 10.1593 12.1373 10.1802 12.1036 10.2011C12.0699 10.2219 12.0345 10.2428 11.9976 10.2637C11.9253 10.3038 11.8499 10.3424 11.7744 10.3761C11.7085 10.405 11.6411 10.4323 11.5737 10.458C11.4998 10.4853 11.4259 10.5094 11.3488 10.5302C11.2348 10.5624 11.1208 10.5864 11.0036 10.6041C10.9201 10.617 10.8334 10.6266 10.7483 10.633C10.6583 10.6394 10.5668 10.641 10.4753 10.641C10.3741 10.6394 10.2729 10.633 10.1702 10.6218C10.0947 10.6137 10.0192 10.6025 9.94375 10.5897C9.87791 10.5784 9.81208 10.564 9.74624 10.5479C9.71091 10.5399 9.67719 10.5302 9.64186 10.5206C9.54551 10.4949 9.44916 10.4676 9.35281 10.4403C9.30464 10.4259 9.25646 10.413 9.20989 10.3986C9.13763 10.3777 9.06698 10.3552 8.99632 10.3327C8.93851 10.3151 8.8807 10.2958 8.82289 10.2765C8.76829 10.2589 8.71209 10.2412 8.65749 10.2219L8.54508 10.1834C8.50012 10.1673 8.45355 10.1513 8.40859 10.1352L8.31224 10.0999C8.24801 10.0774 8.18378 10.0533 8.12115 10.0292C8.08421 10.0148 8.04728 10.0019 8.01035 9.98748C7.96057 9.96821 7.91239 9.94894 7.86261 9.92967C7.81123 9.90879 7.75823 9.88792 7.70685 9.86704L7.60568 9.82529L7.48043 9.7739L7.38408 9.73376L7.28452 9.6904L7.1978 9.65186L7.11912 9.61653L7.03883 9.5796L6.95693 9.54106L6.85255 9.49288L6.74336 9.4415C6.70482 9.42223 6.66628 9.40456 6.62774 9.38529L6.52978 9.33712C4.80192 8.4748 3.24267 7.31218 1.92269 5.90227C1.88254 5.86052 1.8167 5.85731 1.77335 5.89746C1.75247 5.91673 1.73962 5.94563 1.73962 5.97454L1.74284 10.9413V11.3444C1.74284 11.5788 1.85845 11.7972 2.05276 11.9273C3.31654 12.772 4.80353 13.22 6.32424 13.2168Z" fill="#3370FF"/>
<path d="M14.8656 6.21539C13.8844 5.73525 12.7619 5.63248 11.7101 5.92795C11.6652 5.94079 11.6218 5.95364 11.5784 5.96649C11.5479 5.97612 11.5174 5.98576 11.4853 5.997C11.4243 6.01787 11.3633 6.04036 11.3039 6.06284C11.1963 6.10459 11.0919 6.15116 10.9875 6.20094C10.8783 6.25393 10.7707 6.31174 10.6663 6.37276C10.5588 6.43539 10.456 6.50283 10.3548 6.57509C10.2825 6.62648 10.2119 6.67947 10.1428 6.73407C10.0674 6.79509 9.99511 6.85611 9.92445 6.92195C9.88591 6.95728 9.84898 6.99261 9.81044 7.02954L9.61453 7.22224L9.47482 7.36034L9.32227 7.51129L9.17614 7.65581L9.02038 7.80997L8.83892 7.98982L8.70564 8.1215L8.66067 8.16485C8.6398 8.18573 8.61732 8.20821 8.59483 8.22909L8.56272 8.2612L8.51294 8.30777C8.49367 8.32544 8.476 8.34149 8.45673 8.35916C7.97338 8.80397 7.43383 9.18455 6.85413 9.49447L6.9585 9.54265L7.0404 9.58119L7.12069 9.61812L7.19938 9.65345L7.28609 9.69199L7.38565 9.73534L7.482 9.77549L7.60725 9.82688L7.70842 9.86863C7.75981 9.8895 7.8128 9.91038 7.86419 9.93125C7.91236 9.95052 7.96214 9.9698 8.01192 9.98907C8.04886 10.0035 8.08579 10.0164 8.12272 10.0308C8.18696 10.0549 8.25119 10.0774 8.31382 10.1015L8.41016 10.1368C8.45513 10.1529 8.50009 10.1689 8.54666 10.185L8.65907 10.2235C8.71366 10.2412 8.76826 10.2604 8.82447 10.2781C8.88228 10.2974 8.94008 10.315 8.99789 10.3343C9.06855 10.3568 9.14081 10.3777 9.21147 10.4002C9.25964 10.4146 9.30782 10.4291 9.35439 10.4419C9.45073 10.4692 9.54708 10.4965 9.64343 10.5222C9.67876 10.5318 9.71248 10.5399 9.74781 10.5495C9.81365 10.5656 9.87949 10.5784 9.94533 10.5912C10.0208 10.6041 10.0963 10.6153 10.1717 10.6234C10.2745 10.6346 10.3757 10.641 10.4769 10.6426C10.5684 10.6442 10.6599 10.641 10.7498 10.6346C10.8366 10.6282 10.9217 10.6185 11.0052 10.6057C11.1208 10.588 11.2364 10.5623 11.3504 10.5318C11.4259 10.511 11.5014 10.4869 11.5752 10.4596C11.6427 10.4355 11.7101 10.4082 11.776 10.3777C11.8514 10.344 11.9269 10.3054 11.9992 10.2653C12.0345 10.246 12.0698 10.2251 12.1052 10.2026C12.1405 10.1818 12.1726 10.1593 12.2047 10.1384C12.2561 10.1031 12.3075 10.0677 12.3573 10.0292C12.4006 9.99709 12.4424 9.96337 12.4825 9.92804C12.5548 9.86542 12.6254 9.79797 12.6929 9.72732C12.7266 9.69199 12.7587 9.65666 12.7908 9.61973C12.831 9.57316 12.8711 9.52498 12.9081 9.47681C12.9386 9.43827 12.9675 9.39812 12.9964 9.35637C13.0767 9.24075 13.1505 9.12032 13.2164 8.99506L13.2919 8.84572L13.9631 7.50807L13.9711 7.49202C14.1927 7.01348 14.4946 6.58312 14.8656 6.21539Z" fill="#133C9A"/></svg>飞书登录</span>
<!--            <span @click="ddClick" style="margin-left: 10px"><i class="iconfont icon-dingding"></i>钉钉扫码登录</span>-->
          </p>
          <p style="color:#409EFF;cursor: pointer;" @click="ddClick">
          </p>
        </div>
        <div v-show="isDD">
          <div style="text-align: center;width: 220px;margin: 0 auto;">
            <p>请使用<span class="blue" style="color: #1E9FFF;font-weight: 600">钉钉App</span>扫码登录</p>
            <div id="login_container"></div>
          </div>
          <p style="color:#409EFF;cursor: pointer;" @click="isDD = false">
            <span>账号密码登录</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getAuth, login, loginByDingTalk, LoginDingDing, loginByFeishuCode} from '@/api/login'
import {getDingtalkAppId, getDingTalkClient, getFeishuApp} from "@/api/common";
import {isFeishuClient, getFeishuH5AuthCode, buildFeishuAuthorizeUrl, getFeishuRedirectUri} from "@/utils/feishu";
import {getPermissions} from "@/api/auth";
import store from "@/store";
import {LOGIN_PWD_DECRYPT} from "@/config/business/code";
import {removePem} from "@/utils/pem";
import CaptchaSlider from "@/components/CaptchaSlider/index.vue";

export default {
  name: 'login',
  components: {CaptchaSlider},
  data() {
    return {
      isDD: false,
      params: {
        account: '',
        password: ''
      },
      errmessage: '',
      loginLoading: false,
      dialogVerify: false,
      keyVerify: new Date().getTime(),
      redirect: '/',
      otherQuery: {},
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query
        if (query) {
          this.redirect = query.redirect
          this.otherQuery = this.getOtherQuery(query)
        }
      },
      immediate: true
    }
  },
  mounted: function () {
    this.redirect = this.$route.query.redirect || '/';
    this.dingRedirectDeal();
    // 飞书客户端内进入登录页：自动免登
    this.feishuAutoLogin();
  },
  methods: {
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== 'redirect') {
          acc[cur] = query[cur]
        }
        return acc
      }, {})
    },
    doLogin() {
      if (!this.params.account) {
        this.errmessage = '请输入用户名';
        return false
      }
      if (!this.params.password) {
        this.errmessage = '请输入密码';
        return false
      }
      this.keyVerify = new Date().getTime()
      this.dialogVerify = true
    },
    callbackVerifySuccess() {
      this.dialogVerify = false
      this.keyVerify = new Date().getTime()
      this.loginSubmit();
    },
    async loginSubmit() {
      // event.preventDefault();

      if (!this.params.account) {
        this.errmessage = '请输入用户名';
        return false
      }
      if (!this.params.password) {
        this.errmessage = '请输入密码';
        return false
      }
      this.loginLoading = true
      this.errmessage = '';
      let data = this.params;
      await login(data).then(res => {
        if (res.success) {
          let tokenData = res.model
          this.$utils.lsSet('token', tokenData.access_token, tokenData.expires_in * 1000)
          this.$store.dispatch('login', tokenData);
          this.loginSuccess(tokenData);
        } else if (res.code === LOGIN_PWD_DECRYPT) {
          // 登录公钥异常
          removePem()
        } else {
          this.errmessage = res.message;
        }
      })
      this.loginLoading = false

      return false;
    },
    // 登录成功后
    async loginSuccess() {
      // 加载权限
      let permissions = await getPermissions().then((res) => {
        return res.model;
      })
      await store.commit('handleUserPermissions', permissions)

      //加载用户信息：登录成功后， 获取用户信息
      let userInfo = await getAuth().then(res => {
        return res.model;
      })
      // 检测是否绑定钉钉
      this.$EventBus.$emit('bind-dd')
      await this.$store.dispatch('login', userInfo);
      //页面跳转到首页-如果有重定向就去重定向
      if (this.redirect) {
        if(this.otherQuery){
          let arr=['authCode','code','state']
          arr.forEach((item)=>{
            if(this.otherQuery[item]){
              delete this.otherQuery[item]
            }
          })

        }
        await this.$router.push({path: this.redirect || '/', query: this.otherQuery})
      } else {
        await this.$router.push({path: '/'})
      }
      // console.log(this.$route.fullPath)
      // await this.$router.push({path: this.$route.fullPath});
    },
    ddClick() {
      this.isDD = true;
      localStorage.removeItem('userDingDing')
      this.ddLogin();
    },
    getQueryVariable(variable) {
      const query = window.location.search.substring(1);
      const vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return (false);
    },
    // 从浏览器地址栏清除 OAuth 一次性授权码参数（code/state/authCode），保留其余参数与 hash 路由
    // 飞书回调的 code 与钉钉扫码 code 同名，消费后必须清除，避免其他组件误读
    stripOAuthQuery() {
      const keys = ['code', 'state', 'authCode']
      const search = window.location.search
      if (!search) return
      const kept = search.substring(1).split('&').filter(item => {
        const k = item.split('=')[0]
        return keys.indexOf(k) === -1
      })
      const newSearch = kept.length ? ('?' + kept.join('&')) : ''
      window.history.replaceState(null, '', window.location.origin + window.location.pathname + newSearch + window.location.hash)
    },
    //钉钉重定向处理方法
    dingRedirectDeal() {
      // http://ad-beta.pblab.com/home?code=6847bcda6a233ed68b978cbed2dad227&state=STATE
      //钉钉登录重定向返回url：http://localhost:8091/login?code=9892f7540e5f32fbb5d0652bf3118eef&authCode=9892f7540e5f32fbb5d0652bf3118eef&state=dddd
      //飞书登录重定向返回url：http://localhost:8091/login?code=03a77844569f231f0984d1e40318040d&state=feishu
      // 飞书授权回调（state=feishu）统一由全局 BindFeishu 消费（含登录/绑定分流，
      // 未绑定账号会跳 /bindFeishu）。这里不再处理，避免与全局 BindFeishu 并发
      // 重复消费一次性授权码 → 飞书报 [20003] The authorization code has been used
      if (this.getQueryVariable('state') === 'feishu') {
        return
      }
      let authCode = this.getQueryVariable('authCode')
      if (authCode) {
        //判定为钉钉登录 4e972d074ac03598ad2f74d283cb0013
        loginByDingTalk(authCode).then(res => {
          //处理
          if (res.success) {
            this.handleR(res.model)
          }
          else {
            this.$message.error(res.message)
            this.$router.push({path: '/login'});
          }
        })

      } else {
        //判断是否扫码登录
        let code = this.getQueryVariable('code')
        if (code) {
          LoginDingDing({code: code}).then(res => {
            if (res.success) {
              //处理
              this.handleR(res.model)

            } else {
              this.$message.error(res.message)
              this.$router.push({path: '/login'});
            }
          });
        }
      }
    },
    handleR(tokenData) {
      if (!tokenData.is_register) {
        // 已有账号 直接登录
        // let tokenData = res.model
        this.$utils.lsSet('token', tokenData.access_token, tokenData.expires_in * 1000)
        this.$store.dispatch('login', tokenData);
        this.loginSuccess(tokenData);
      } else {
        // 无账号 前往绑定页面
        localStorage.setItem('userDingDing', JSON.stringify(tokenData.user_info))
        this.$router.push({path: '/bindDingDing'});
      }
    },
    async ddLogin() {
      //获取钉钉应用ID
      let {app_id} = await getDingtalkAppId().then((res) => {
        return res.model;
      })
      this.$nextTick(() => {
        const dingAppId = app_id
        let uri = `${window.location.origin}${window.location.pathname}`
        let redirectUrl = encodeURIComponent(uri);
        let goto = encodeURIComponent(`https://oapi.dingtalk.com/connect/qrconnect?appid=${dingAppId}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${redirectUrl}`)
        // eslint-disable-next-line no-undef
        DDLogin({
          id: "login_container",//这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="login_container"></div>或<span id="login_container"></span>
          goto: goto, //请参考注释里的方式
          style: "border:none;background-color:#FFFFFF;",
          width: "220",
          height: "305"
        });
        let handleMessage = function (event) {
          var origin = event.origin;
          if (origin === "https://login.dingtalk.com") { //判断是否来自ddLogin扫码事件。
            const loginTmpCode = event.data; //拿到loginTmpCode后就可以在这里构造跳转链接进行跳转了
            window.parent.postMessage(loginTmpCode, '*');
            //1.跳转到主页面，微应用自身截取code比对用户信息
            window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${dingAppId}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=http://&loginTmpCode=${loginTmpCode}`;
          }
        };
        if (typeof window.addEventListener != 'undefined') {
          window.addEventListener('message', handleMessage, false);
        } else if (typeof window.attachEvent != 'undefined') {
          window.attachEvent('onmessage', handleMessage);
        }

      })
    },
    async ddQuickLogin() {
      //获取钉钉应用ID
      let {client_id} = await getDingTalkClient().then((res) => {
        return res.model;
      })
      if (client_id) {
        this.$nextTick(() => {
          let uri = `${window.location.origin}${window.location.pathname}`
          let redirectUrl = encodeURIComponent(uri);
          let url = `https://login.dingtalk.com/oauth2/auth?redirect_uri=${redirectUrl}&response_type=code&client_id=${client_id}&scope=openid&state=dddd&prompt=consent`
          // eslint-disable-next-line no-console
          window.location.href = url

        })
      }

    },
    /**
     * 飞书授权登录（点击「飞书登录」入口）
     * 飞书客户端内会自动静默授权；浏览器内打开飞书登录页（支持扫码/账密）
     */
    async fsQuickLogin() {
      const {model} = await getFeishuApp()
      if (!model || !model.app_id) {
        this.$message.error('飞书应用未配置，请联系管理员')
        return
      }
      // 回调地址优先使用后端返回的白名单 redirect_uri（与飞书安全配置重定向 URL 完全一致），
      // 避免自行拼接的地址不在白名单导致授权后无法回调
      const redirectUri = model.redirect_uri || getFeishuRedirectUri('/home')
      // 保存重定向目标：飞书授权回调跨页面加载会丢失 redirect query，
      // 由回调消费方（全局 BindFeishu）登录成功后据此跳转
      sessionStorage.setItem('feishu_redirect', this.redirect || '/')
      window.location.href = buildFeishuAuthorizeUrl(model, redirectUri, 'feishu')
    },
    /**
     * 飞书客户端内进入登录页：自动免登（仅触发一次，避免授权回调后被重复触发）
     * ① 优先 H5 JS-SDK 静默获取授权码；② 失败则回退为跳转飞书授权页（客户端内静默授权）
     */
    async feishuAutoLogin() {
      if (!isFeishuClient()) return
      if (sessionStorage.getItem('isFeishuAutoLogin')) return
      sessionStorage.setItem('isFeishuAutoLogin', '1')
      try {
        const {model: feishuApp} = await getFeishuApp()
        if (!feishuApp || !feishuApp.app_id) {
          sessionStorage.removeItem('isFeishuAutoLogin')
          return
        }
        // 优先使用后端白名单 redirect_uri（命中飞书安全配置），回退才用 /home
        const redirectUri = feishuApp.redirect_uri || getFeishuRedirectUri('/home')
        try {
          const code = await getFeishuH5AuthCode(feishuApp.app_id, feishuApp.h5_sdk_url)
          if (code) {
            this.feishuLoginByCode(code)
            return
          }
        } catch (e) {
          // SDK 不可用，回退为跳转授权页（飞书客户端内会静默授权后跳回）
        }
        // 降级跳授权前同样保存重定向目标（登录成功后据此跳转）
        sessionStorage.setItem('feishu_redirect', this.redirect || '/')
        window.location.href = buildFeishuAuthorizeUrl(feishuApp, redirectUri, 'feishu')
      } catch (e) {
        sessionStorage.removeItem('isFeishuAutoLogin')
      }
    },
    /**
     * 飞书授权码登录
     */
    feishuLoginByCode(code) {
      loginByFeishuCode(code).then(res => {
        if (res.success) {
          this.handleFeishuR(res.model)
        } else {
          sessionStorage.removeItem('isFeishuAutoLogin')
          this.$message.error(res.message)
          this.$router.push({path: '/login'});
        }
      })
    },
    /**
     * 飞书登录结果处理：已匹配到账号直接登录，否则前往飞书绑定页面
     */
    handleFeishuR(tokenData) {
      sessionStorage.removeItem('isFeishuAutoLogin')
      if (!tokenData.is_register) {
        // 已有账号 直接登录
        this.$utils.lsSet('token', tokenData.access_token, tokenData.expires_in * 1000)
        this.$store.dispatch('login', tokenData);
        this.loginSuccess(tokenData);
      } else {
        // 无账号 前往飞书绑定页面
        localStorage.setItem('userFeishu', JSON.stringify(tokenData.user_info))
        this.$router.push({path: '/bindFeishu'});
      }
    },
  }
}
</script>

<style scoped>
.login {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: linear-gradient(135deg, rgba(98, 198, 254, 1) 0%, rgba(151, 96, 237, 1) 100%);
  z-index: 1;
  text-align: center;
}

.login .login_box {
  /* width:960px; */
  height: 560px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -550px;
  margin-top: -280px;
  display: flex;
  z-index: 2;
  /* background:#fff; */
  /* box-shadow: 0px 0px 3px 2px rgba(149,173,198,0.5); */
  align-items: center;
}

.login .login_box .left {
  width: 562px;
  height: 268px;
  margin-right: 50px;
  position: relative;
}

.img1 {
  position: absolute;
  top: 40px;
  left: 50px;
  width: 192px;
  height: 27px;
}

.login .login_box .left .img2 {
  width: 100%;
  height: 100%;
}

.login .login_box .right {
  flex: 1;
  padding: 100px 40px;
  background: #fff;
}

.login .login_box .right .top {
  position: relative;
  height: 33px;
  /*margin-bottom: 64px;*/
}

.login .login_box .right .top h1 {
  font-size: 20px;
  font-weight: 400;
  color: rgba(50, 50, 50, 1);
  line-height: 28px;
}

.login .login_box .right .top .line {
  width: 26px;
  height: 2px;
  background: #3296FF;
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -13px;
}

.login .login_box .mid {
  margin-bottom: 64px;
  position: relative;
}

.login .login_box .mid .input1 {
  margin-bottom: 32px;
}

.login .login_box .mid .err {
  position: absolute;
  bottom: -40px;
  color: #E03F3D;
  text-align: left;
  font-size: 14px;
}

.login .login_box .btn {
  width: 100%;
}

/* 飞书登录入口图标（飞书官方 logo，来源：feishucdn favicon-logo.svg） */
.fs-login-logo {
  display: inline-block;
  width: 18px;
  height: 18px;
  vertical-align: -5px;
  margin-right: 4px;
}

login-btn {
  background-color: #409EFF;
}
</style>
<style>
input {
  background: transparent;
}

input:-webkit-autofill {
  -webkit-text-fill-color: #606266 !important;
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
}

</style>
